"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornScreenHeader = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcornScreenHeader = function (props) {
    var _a, _b;
    return (react_1.default.createElement("div", { className: "cc-page-header" },
        react_1.default.createElement("div", { className: "cc-page-header__primary" },
            react_1.default.createElement("nav", { "aria-label": "breadcrumbs" },
                react_1.default.createElement("ol", { className: "c-breadcrumb" },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(react_router_dom_1.Link, { to: '/' }, "Dashboard")), (_a = props.crumbs) === null || _a === void 0 ? void 0 :
                    _a.map(function (crumb) { return (react_1.default.createElement("li", { key: crumb.path },
                        react_1.default.createElement(react_router_dom_1.Link, { to: crumb.path }, crumb.name))); }),
                    react_1.default.createElement("li", { "aria-current": "location" }, (_b = props.crumbTitle) !== null && _b !== void 0 ? _b : props.title))),
            react_1.default.isValidElement(props.title) ? props.title : react_1.default.createElement("h1", { className: "c-heading +h1" }, props.title)),
        react_1.default.createElement("div", { className: "cc-page-header__secondary" }, props.callToActionContent)));
};
exports.AcornScreenHeader = AcornScreenHeader;
//# sourceMappingURL=AcornScreenHeader.js.map